// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/react-datepicker/dist/react-datepicker.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-datepicker {
	border: none;
	box-shadow: 0 20px 35px 0 rgba(0, 0, 0, 0.25);
	width: 290px;
}

.react-datepicker-wrapper {
	width: 100%;
}

.react-datepicker__header {
	border-bottom: none;
}

.react-datepicker-popper {
	z-index: 99 !important;
}

.react-datepicker__input-time-container {
	padding: 10px 15px;
}

.react-datepicker-time__caption,
.react-datepicker__current-month {
	display: none !important;
}

.react-datepicker__input-time-container,
.react-datepicker-time__input-container,
.react-datepicker-time__input,
.react-datepicker-time__input input {
	margin: 0 !important;
	width: 100% !important;
}

.react-datepicker__day {
	line-height: 2.2rem;
	margin: 0;
	width: 2.2rem;
}

.react-datepicker__day:hover,
.react-datepicker__day--selected,
.react-datepicker__day--selected:hover {
	border-radius: 50%;
}

.react-datepicker__day--selected,
.react-datepicker__year-text--selected,
.react-datepicker__month--selected,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--keyboard-selected {
	background-color: var(--chakra-colors-lightBlue-60) !important;
}

.react-datepicker__day--disabled {
	background-color: transparent !important;
	cursor: not-allowed;
}

.react-datepicker__header__dropdown {
	margin-bottom: 10px;
}

.react-datepicker__header__dropdown select {
	background-color: transparent;
	cursor: pointer;
	font-size: 16px;
	font-weight: 500;
	outline: none;
	text-align: center;
}

.react-datepicker__header,
.react-datepicker__day:hover,
.react-datepicker__year-text:hover,
.react-datepicker__month-text:hover {
	background-color: #edf2f5;
}

.react-datepicker__year-wrapper {
	display: grid;
	flex-wrap: wrap;
	max-width: 100%;
}

.react-datepicker__year-text,
.react-datepicker__month-text {
	width: 100% !important;
}

.react-datepicker__month-wrapper {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
}

.react-datepicker__month-container {
	float: none;
}

.react-datepicker__navigation {
	top: 8px;
}

.react-datepicker__navigation-icon::before {
	border-color: #000;
	border-width: 1px 1px 0 0;
	height: 8px;
	width: 8px;
}

input[type="time"]::-webkit-inner-spin-button,
input[type="time"]::-webkit-clear-button,
input[type="time"]::-webkit-calendar-picker-indicator {
	display: none;
}

input[type="time"]::-webkit-datetime-edit-hour-field:focus,
input[type="time"]::-webkit-datetime-edit-minute-field:focus,
input[type="time"]::-webkit-datetime-edit-second-field:focus,
input[type="time"]::-webkit-datetime-edit-ampm-field:focus {
	background-color: var(--chakra-colors-darkBrandBlue-40);
}

@media only screen and (max-width: 480px) {
	.react-datepicker,
	.react-datepicker-popper {
		width: 100% !important;
	}

	.react-datepicker__year-text {
		padding: 0.3rem;
	}

	.react-datepicker__month-text {
		padding: 1rem;
	}

	.react-datepicker__day-names {
		display: flex;
		margin: 0.4rem;

		.react-datepicker__day-name {
			flex: 1;
		}
	}

	.react-datepicker__week {
		display: flex;

		.react-datepicker__day-name,
		.react-datepicker__day {
			flex: 1;
		}

		.react-datepicker__day {
			line-height: 3rem;
			width: 3rem;
		}
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/blocks/CalendarSelector/style.css"],"names":[],"mappings":"AAEA;CACC,YAAY;CACZ,6CAA6C;CAC7C,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,wBAAwB;AACzB;;AAEA;;;;CAIC,oBAAoB;CACpB,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;CACnB,SAAS;CACT,aAAa;AACd;;AAEA;;;CAGC,kBAAkB;AACnB;;AAEA;;;;;CAKC,8DAA8D;AAC/D;;AAEA;CACC,wCAAwC;CACxC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,6BAA6B;CAC7B,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,kBAAkB;AACnB;;AAEA;;;;CAIC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,eAAe;CACf,eAAe;AAChB;;AAEA;;CAEC,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,qCAAqC;AACtC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,WAAW;CACX,UAAU;AACX;;AAEA;;;CAGC,aAAa;AACd;;AAEA;;;;CAIC,uDAAuD;AACxD;;AAEA;CACC;;EAEC,sBAAsB;CACvB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;EACb,cAAc;;EAEd;GACC,OAAO;EACR;CACD;;CAEA;EACC,aAAa;;EAEb;;GAEC,OAAO;EACR;;EAEA;GACC,iBAAiB;GACjB,WAAW;EACZ;CACD;AACD","sourcesContent":["@import url(\"react-datepicker/dist/react-datepicker.css\");\n\n.react-datepicker {\n\tborder: none;\n\tbox-shadow: 0 20px 35px 0 rgba(0, 0, 0, 0.25);\n\twidth: 290px;\n}\n\n.react-datepicker-wrapper {\n\twidth: 100%;\n}\n\n.react-datepicker__header {\n\tborder-bottom: none;\n}\n\n.react-datepicker-popper {\n\tz-index: 99 !important;\n}\n\n.react-datepicker__input-time-container {\n\tpadding: 10px 15px;\n}\n\n.react-datepicker-time__caption,\n.react-datepicker__current-month {\n\tdisplay: none !important;\n}\n\n.react-datepicker__input-time-container,\n.react-datepicker-time__input-container,\n.react-datepicker-time__input,\n.react-datepicker-time__input input {\n\tmargin: 0 !important;\n\twidth: 100% !important;\n}\n\n.react-datepicker__day {\n\tline-height: 2.2rem;\n\tmargin: 0;\n\twidth: 2.2rem;\n}\n\n.react-datepicker__day:hover,\n.react-datepicker__day--selected,\n.react-datepicker__day--selected:hover {\n\tborder-radius: 50%;\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__year-text--selected,\n.react-datepicker__month--selected,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--keyboard-selected {\n\tbackground-color: var(--chakra-colors-lightBlue-60) !important;\n}\n\n.react-datepicker__day--disabled {\n\tbackground-color: transparent !important;\n\tcursor: not-allowed;\n}\n\n.react-datepicker__header__dropdown {\n\tmargin-bottom: 10px;\n}\n\n.react-datepicker__header__dropdown select {\n\tbackground-color: transparent;\n\tcursor: pointer;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\toutline: none;\n\ttext-align: center;\n}\n\n.react-datepicker__header,\n.react-datepicker__day:hover,\n.react-datepicker__year-text:hover,\n.react-datepicker__month-text:hover {\n\tbackground-color: #edf2f5;\n}\n\n.react-datepicker__year-wrapper {\n\tdisplay: grid;\n\tflex-wrap: wrap;\n\tmax-width: 100%;\n}\n\n.react-datepicker__year-text,\n.react-datepicker__month-text {\n\twidth: 100% !important;\n}\n\n.react-datepicker__month-wrapper {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(3, 1fr);\n}\n\n.react-datepicker__month-container {\n\tfloat: none;\n}\n\n.react-datepicker__navigation {\n\ttop: 8px;\n}\n\n.react-datepicker__navigation-icon::before {\n\tborder-color: #000;\n\tborder-width: 1px 1px 0 0;\n\theight: 8px;\n\twidth: 8px;\n}\n\ninput[type=\"time\"]::-webkit-inner-spin-button,\ninput[type=\"time\"]::-webkit-clear-button,\ninput[type=\"time\"]::-webkit-calendar-picker-indicator {\n\tdisplay: none;\n}\n\ninput[type=\"time\"]::-webkit-datetime-edit-hour-field:focus,\ninput[type=\"time\"]::-webkit-datetime-edit-minute-field:focus,\ninput[type=\"time\"]::-webkit-datetime-edit-second-field:focus,\ninput[type=\"time\"]::-webkit-datetime-edit-ampm-field:focus {\n\tbackground-color: var(--chakra-colors-darkBrandBlue-40);\n}\n\n@media only screen and (max-width: 480px) {\n\t.react-datepicker,\n\t.react-datepicker-popper {\n\t\twidth: 100% !important;\n\t}\n\n\t.react-datepicker__year-text {\n\t\tpadding: 0.3rem;\n\t}\n\n\t.react-datepicker__month-text {\n\t\tpadding: 1rem;\n\t}\n\n\t.react-datepicker__day-names {\n\t\tdisplay: flex;\n\t\tmargin: 0.4rem;\n\n\t\t.react-datepicker__day-name {\n\t\t\tflex: 1;\n\t\t}\n\t}\n\n\t.react-datepicker__week {\n\t\tdisplay: flex;\n\n\t\t.react-datepicker__day-name,\n\t\t.react-datepicker__day {\n\t\t\tflex: 1;\n\t\t}\n\n\t\t.react-datepicker__day {\n\t\t\tline-height: 3rem;\n\t\t\twidth: 3rem;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
